export const CHARGE_BREAKDOWN_GROUPS = [
  {
    id: "monthly",
    label: "Monthly Fees",
    color: "#081E56",
    types: ["Monthly Fees"],
  },
  {
    id: "aml",
    label: "AML Checks",
    color: "#515D84",
    types: ["AML Checks", "Smart Search", "SmartSearch", "RedFlag", "Red Flag"],
  },
  {
    id: "paraplanning",
    label: "Paraplanning",
    color: "#F59E0B",
    types: ["Paraplanning"],
  },
  { id: "expenses", label: "Suspense", color: "#BA1A1A", types: ["Suspense"] },
  {
    id: "website",
    label: "Website & Graphics",
    color: "#15803D",
    types: ["Website & Graphics"],
  },
  {
    id: "technology",
    label: "Technology",
    color: "#D5D162",
    types: ["Technology", "ProCeding"],
  },
  { id: "miscellaneous", label: "Miscellaneous", color: "#3F5D9B", types: [] },
];

export const buildChargeBreakdown = (records = []) => {
  const groups = CHARGE_BREAKDOWN_GROUPS.map((group) => ({
    ...group,
    cents: 0,
    count: 0,
  }));
  records.forEach((record) => {
    if (record.excludeFromBalance === true) return;
    if (
      typeof record.amountCharged !== "number" ||
      !Number.isFinite(record.amountCharged)
    )
      return;
    const group =
      groups.find((item) => item.types.includes(record.chargeType)) ||
      groups[groups.length - 1];
    group.cents += Math.round(record.amountCharged * 100);
    group.count += 1;
  });
  const totalCents = groups.reduce((sum, group) => sum + group.cents, 0);
  return {
    total: totalCents / 100,
    rows: groups.map((group) => ({
      ...group,
      amount: group.cents / 100,
      percentage: totalCents > 0 ? (group.cents / totalCents) * 100 : 0,
    })),
  };
};
